import api from "api";

export const RECENT_DESIGNS_ASYNC_ACTION_START =
  "RECENT_DESIGNS_ASYNC_ACTION_START";
export const RECENT_DESIGNS_ASYNC_ACTION_SUCCESS =
  "RECENT_DESIGNS_ASYNC_ACTION_SUCCESS";
export const RECENT_DESIGNS_ASYNC_ACTION_ERROR =
  "RECENT_DESIGNS_ASYNC_ACTION_ERROR";

function designsAsyncActionStart() {
  return {
    type: RECENT_DESIGNS_ASYNC_ACTION_START,
  };
}

function designsAsyncActionSuccess(data) {
  return {
    type: RECENT_DESIGNS_ASYNC_ACTION_SUCCESS,
    data,
  };
}

function designsAsyncActionError(error) {
  return {
    type: RECENT_DESIGNS_ASYNC_ACTION_ERROR,
    error,
  };
}

export function getRecentDesignsAsync(limit = 5) {
  return (dispatch, getState) => {
    dispatch(designsAsyncActionStart());
    return api
      .request(`design/designlist?limit=${limit}`, "get")
      .then((data) => {
        dispatch(designsAsyncActionSuccess(data));
        return data;
      })
      .catch((err) => {
        dispatch(designsAsyncActionError("Unable to get recent designs"));
        throw err;
      });
  };
}
